import React from 'react';

import CatalogOnboarding from './Web';

export default function Catalog({ handler }) {
  // Mobile and Web use the same component that web (Catalog)
  return <CatalogOnboarding handler={handler} />;
}